<template>
  <div class="qrcode">
    <div ref="qrcode" />
    <p
      v-if="showText"
      class="text"
    >
      {{ text }}
    </p>
  </div>
</template>

<style lang="less" scoped>
.qrcode {
  .text {
    margin: 0.5em 0;
  }
}
</style>

<script>
const debug = require('debug')('ccs:component:qrcode');
export default {
	props: {
		text: {
			type: String,
			required: true
		},
		width: {
			type: Number,
			default: 200
		},
		height: {
			type: Number,
			default: 200
		},
		showText: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			qrcode: null
		};
	},
	beforeCreate() {
		if (!window.QRCode)
			throw new Error(
				'[QRCode](https://github.com/davidshimjs/qrcodejs) is not defined'
			);
	},
	mounted() {
		/* eslint no-undef:0 */
		if (this.qrcode && typeof this.qrcode.clear === 'function')
			this.qrcode.clear();
		debug(
			'[init] text: %s, width: %s, height: %s, showText: %s',
			this.text,
			this.width,
			this.height,
			this.showText
		);
	
		this.qrcode = new QRCode(this.$refs.qrcode, {
			text: this.text,
			width: this.width,
			height: this.height,
			colorDark: '#000000',
			colorLight: '#ffffff',
			correctLevel: QRCode.CorrectLevel.H
		});
	},

	beforeDestroy() {
		if (this.qrcode && typeof this.qrcode.clear === 'function') {
			this.qrcode.clear();
			this.qrcode = null;
		}
	}
};
</script>
